import { render } from "./aggrement.vue?vue&type=template&id=2df2655f"
import script from "./aggrement.vue?vue&type=script&lang=js"
export * from "./aggrement.vue?vue&type=script&lang=js"

import "./aggrement.vue?vue&type=style&index=0&id=2df2655f&lang=less"
script.render = render

export default script